var map = {
	"./1.jpg": "bf07",
	"./card-user-review.png": "51e9",
	"./carousel-text.png": "77ba",
	"./carousel.png": "db2f",
	"./circle-card.png": "92f5",
	"./gold-card.png": "801f",
	"./horizontal-banner.png": "6ec3",
	"./paragraph.png": "a134",
	"./product-card.png": "14ca",
	"./title.png": "1509"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1cb9";